import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/cancel-red.png'
import _imports_1 from '@/assets/img/icon/save-blue.png'
import _imports_2 from '@/assets/img/icon/edit-blue.svg'


const _hoisted_1 = {
  id: "test",
  class: "table-plotting"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_4 = { class: "flex items center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-7px text-xs" }
const _hoisted_5 = { class: "color-grey-5" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-green text-sm font-semibold"
}
const _hoisted_9 = {
  key: 1,
  class: "text-primary text-sm font-semibold"
}
const _hoisted_10 = {
  key: 2,
  class: "text-orange-1 text-sm font-semibold"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "pi pi-times text-red-600 font-bold text-xl ml-6"
}
const _hoisted_13 = {
  key: 1,
  class: "pi pi-times-circle text-red-600 font-bold text-xl ml-6"
}
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "inline-flex gap-3",
  style: {"width":"100px"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "edit-box"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary font-semibold" }, "Edit", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_27 = { class: "text-base" }
const _hoisted_28 = { class: "text-base" }
const _hoisted_29 = { class: "text-base" }
const _hoisted_30 = { class: "text-base" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = { class: "font-normal text-sm text-grey" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "font-normal text-sm text-grey" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Lihat Detail"), -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Lihat Detail"), -1)
const _hoisted_37 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1)
const _hoisted_39 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_40 = { class: "text-center text-grey text-base font-normal" }

import {
  reactive,
  ref,
  toRefs,
  computed,
  getCurrentInstance,
  onMounted
} from 'vue'
import type { PropType } from 'vue'
import { useStore } from 'vuex'
import DataTable from 'primevue/datatable'
import Button from 'primevue/button'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import InputText from 'primevue/inputtext'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import { IPlotting } from '@/utils/interfaces/iPlotting'
import Paginator from '@/views/components/paginator/Paginator.vue'
import { PageState } from 'primevue/paginator'
import * as yup from 'yup'
import ListActions from '@/views/components/list/ListActions.vue'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'
import HjpModalDefault from '@/views/components/modal/ModalDefault.vue'
import OverlayPanel from 'primevue/overlaypanel'
import PassengerLogDialog from '@/views/pages/roster/airport/component/PassengerLog.vue'
import moment from 'moment'
import Popper from 'vue3-popper'
import { isNullOrEmptyString } from '@devexpress/analytics-core/analytics-internal'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import InfoScheduleDialog from '@/views/pages/roster/airport/component/infoScheduleDialog.vue'

type TSchemaRowForm = yup.InferType<typeof schemaRowForm>


export default /*#__PURE__*/_defineComponent({
  __name: 'TableRoster',
  props: {
  plottingList: {
    type: Array as PropType<Array<IPlotting>>,
    default: () => []
  },
  isEdit: {
    type: Boolean,
    default: true
  },
  isRoster: {
    type: Boolean,
    default: false
  },
  totalRecords: {
    type: Number,
    default: 0
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  dateFilter: {
    type: Date,
    default: null
  }
},
  emits: ["submit", "changePage", "onChangeStatusRoster", "onChangeVehicleRoster", "onDeactiveRoster", "onChangeStatusActiveRoster"],
  setup(__props, { emit }: { emit: ({
  (event: 'submit', param: any): void
  (event: 'changePage', param: PageState): void
  (event: 'onChangeStatusRoster'): void
  (event: 'onChangeVehicleRoster'): void
  (event: 'onDeactiveRoster'): void
  (event: 'onChangeStatusActiveRoster'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const {
  isEdit,
  isRoster,
  totalRecords,
  isLoading,
  dateFilter
} = toRefs(props)

const plottingList = computed(() => props.plottingList)
const filterDate = computed(() => moment(props.dateFilter.toDateString()).format('YYYY-MM-DD'))

const endpoint = `roster/v1/${isRoster.value ? 'Roster' : 'Plotting'}`
const endpointTransactionPp = 'transaction/v1/TransactionPp'
const moduleStore = 'plotting'
const schemaRowForm = yup.object().shape({
  // conductor: yup.object().required(),
  driver: yup.object().required(),
  // helper: yup.object()
})

const app = getCurrentInstance()
const {
  $icon,
  $toast
} = app!.appContext.config.globalProperties
const dataRow = ref(null) as any
const refOverlayAction = ref()
const editRosterTitle = ref('Edit')
const changeStatusRosterTitle = ref('Ganti Status')
const changeVehicleRosterTitle = ref('Ganti Kendaraan')
const currentSchedules = ref([]) as any
const isValidCondectur = ref(true)
const isShowPassengerLog = ref(false)
const expandedRowsList = ref([])
const showScheduleDialog = ref(false)
const selectedRit = ref(null) as any
const defaultGuid = ref('00000000-0000-0000-0000-000000000000')
const defaultEditTimeout = ref(0)

const store = useStore()
const plottingSelected = ref(null) as any

const rowForm = reactive({
  // conductor: null as any,
  driver: null as any,
  // helper: null as any
})

const errorsRowForm = reactive({
  // conductor: '',
  driver: '',
  // helper: ''
})

const validate = (field: 'driver') => {
  schemaRowForm
    .validateAt(field, rowForm)
    .then((res) => {
      errorsRowForm[field] = ''
    })
    .catch((err) => {
      errorsRowForm[field] = err.message
    })
}

const modalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/roster-confirmation.svg'),
  title: '',
  subTitle: '',
  btnSubmitTitle: 'OK',
  subTitleHtml: false,
  isDelete: false
})

const editRosterModalConfirmation = reactive({
  show: false,
  imgContent: require('@/assets/img/modal-confirmation/delete-failed.svg'),
  title: '',
  subTitle: '',
  btnSubmitTitle: 'OK',
  subTitleHtml: false,
  isDelete: false
})

const onEditRow = (evt: any = null, val: any) => {
  // console.log('val', val)
  // console.log('dateFilter', filterDate.value)
  // eslint-disable-next-line no-use-before-define
  // console.log('time', timeHasBeenMissed(filterDate.value, dataRow.value.DepartureTime))
  // eslint-disable-next-line no-use-before-define
  if (timeHasBeenMissed(val.RosterDate, dataRow.value.DepartureTime) > -(defaultEditTimeout.value)) {
    editRosterModalConfirmation.title = 'Ooops !'
    editRosterModalConfirmation.subTitle = 'Bus telah melebihi batas waktu edit keberangkatan, tidak bisa melakukan perubahan data'
    editRosterModalConfirmation.show = true
  } else if (val.RosterDetails.length <= 0) {
    editRosterModalConfirmation.title = 'Ooops !'
    editRosterModalConfirmation.subTitle = 'Bus belum memiliki data keberangkatan, mohon isi data keberangkatan bus tersebut pada master trayek'
    editRosterModalConfirmation.show = true
  } else {
    if (isRoster.value) {
      refOverlayAction.value.toggle(evt)
    }
    plottingSelected.value = val.Index
    // console.log('plottingSelected', plottingSelected.value)
    if (val.DriverId) {
      rowForm.driver = {
        label: val.DriverName,
        value: val.DriverId
      }
    } else {
      rowForm.driver = null
    }
    if (val.DriverId) {
      store.dispatch(`${moduleStore}/setSelectedDriver`, {
        label: val.DriverName,
        value: val.DriverId
      })
    }
    store.dispatch('setToggleMinimizeMenu', true)
  }
}

const cancelEditRow = () => {
  plottingSelected.value = null
  // rowForm.conductor = null
  // rowForm.helper = null
  rowForm.driver = null
  // errorsRowForm.conductor = ''
  errorsRowForm.driver = ''
  // errorsRowForm.helper = ''
  // store.dispatch(`${moduleStore}/setSelectedConductor`, null)
  store.dispatch(`${moduleStore}/setSelectedDriver`, null)
  // store.dispatch(`${moduleStore}/setSelectedHelper`, null)
}

const checkIfDriverHasSchedule = async (data: any) => {
  store.dispatch('showLoading')
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpoint}/Driver/${data.value}${returnUrlPrams({
      custom: [['startDate', '=', filterDate.value], ['endDate', '=', filterDate.value]]
    })}`)
    if (!error) {
      if (isRoster.value ? result.DriverRosterCount > 0 : result.DriverPlottingCount > 0) {
        modalConfirmation.title = `Sopir ${result.DriverName} Sudah Mempunyai Jadwal`
        modalConfirmation.subTitle = 'Sopir sudah mempunyai jadwal, mohon cek jadwal sopir berikut ini : '
        modalConfirmation.show = true
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/roster-confirmation.svg')
        modalConfirmation.btnSubmitTitle = 'OK'
        currentSchedules.value = isRoster.value ? result.DriverRosters : result.DriverPlottings
        // console.log('sch', currentSchedules.value)
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const checkIfCondecturHasSchedule = async (data: any) => {
  store.dispatch('showLoading')
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpoint}/Condectur/${data.value}${returnUrlPrams({
      custom: [['startDate', '=', filterDate.value], ['endDate', '=', filterDate.value]]
    })}`)
    if (!error) {
      if (isRoster.value ? result.CondecturRosterCount > 0 : result.CondecturPlottingCount > 0) {
        modalConfirmation.title = `Kondektur ${result.CondecturName} Sudah Mempunyai Jadwal`
        modalConfirmation.subTitle = 'Kondektur sudah mempunyai jadwal, mohon cek jadwal kondektur berikut ini : '
        modalConfirmation.show = true
        modalConfirmation.btnSubmitTitle = 'OK'
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/roster-confirmation.svg')
        currentSchedules.value = isRoster.value ? result.CondecturRosters : result.CondecturPlottings
        // console.log('sch', currentSchedules.value)
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const checkIfCondecturNotDoneDeposit = async (data: any) => {
  store.dispatch('showLoading')
  isValidCondectur.value = true
  currentSchedules.value = []
  try {
    const { result, error, message } = await apiUseCase.get(`${endpointTransactionPp}/Condectur-Transaction-Closed/${data.value}`)
    if (!error) {
      if (result.TransactionPp.length === 0) {
        checkIfCondecturHasSchedule(data)
      } else {
        isValidCondectur.value = false
        modalConfirmation.title = 'Kondektur belum setor pendapatan'
        modalConfirmation.subTitle = 'Kondektur mempunyai setoran yang belum di approve oleh admin. Mohon cek kembali setoran kondektur lalu approve apabila kondektur sudah setor pendapatan'
        modalConfirmation.show = true
        modalConfirmation.btnSubmitTitle = 'Kembali'
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/delete-failed.svg')
      }
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

// const onUpdateConductor = (val: any) => {
//   validate('conductor')
//   store.dispatch(`${moduleStore}/setSelectedConductor`, val ? {
//     label: val.label,
//     value: val.value,
//     username: val.Username
//   } : null)
//   checkIfCondecturNotDoneDeposit(val)
//   // checkIfCondecturHasSchedule(val)
// }

const onUpdateDriver = (val: any) => {
  validate('driver')
  store.dispatch(`${moduleStore}/setSelectedDriver`, val ? {
    label: val.label,
    value: val.value
  } : null)
  checkIfDriverHasSchedule(val)
}

const onUpdateHelper = (val: any) => {
  // console.log('val', val)
  // validate('helper')
  store.dispatch(`${moduleStore}/setSelectedHelper`, val ? {
    label: val.label,
    value: val.value
  } : null)
}

const saveEditRow = (data: IPlotting) => {
  console.log('data', data)
  // if (isValidCondectur.value) {
  schemaRowForm
    .validate(rowForm, { abortEarly: false })
    .then(() => {
      // errorsRowForm.conductor = ''
      errorsRowForm.driver = ''
      // errorsRowForm.helper = ''
      const payload = {
        ...data,
        // ActiveCondecturId: rowForm.conductor?.value,
        // ActiveCondecturName: rowForm.conductor?.label,
        // ActiveCondecturUsername: rowForm.conductor?.Username,
        // PlottingDate: null,
        DriverId: rowForm.driver?.value,
        DriverName: rowForm.driver?.label,
        // HelperId: rowForm.helper?.value,
        // HelperName: rowForm.helper?.label
      }
      // const payload = isRoster.value ? {
      //   ...data,
      //   ActiveCondecturId: rowForm.conductor?.value,
      //   ActiveCondecturName: rowForm.conductor?.label,
      //   ActiveCondecturUsername: rowForm.conductor?.Username,
      //   PlottingDate: null,
      //   DriverId: rowForm.driver?.value,
      //   DriverName: rowForm.driver?.label,
      //   HelperId: rowForm.helper?.value,
      //   HelperName: rowForm.helper?.label
      // } : {
      //   ...data,
      //   Condectur: rowForm.conductor,
      //   CondecturId: rowForm.conductor?.value,
      //   CondecturName: rowForm.conductor?.label,
      //   CondecturUsername: rowForm.conductor?.Username,
      //   PlottingDate: null,
      //   DriverId: rowForm.driver?.value,
      //   DriverName: rowForm.driver?.label,
      //   HelperId: rowForm.helper?.value,
      //   HelperName: rowForm.helper?.label
      // }
      console.log('payload', payload)
      emit('submit', payload)
      setTimeout(() => {
        cancelEditRow()
      }, 500)
    })
    .catch((err) => {
      err.inner.forEach((error: { path: 'driver', message: any }) => {
        errorsRowForm[error.path] = error.message
      })
    })
  // } else {
  //   modalConfirmation.title = 'Kondektur belum setor pendapatan'
  //   modalConfirmation.subTitle = 'Kondektur mempunyai setoran yang belum di approve oleh admin. Mohon cek kembali setoran kondektur lalu approve apabila kondektur sudah setor pendapatan'
  //   modalConfirmation.show = true
  //   modalConfirmation.btnSubmitTitle = 'Kembali'
  //   modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/delete-failed.svg')
  // }
}

const showDropDown = (evt: any, item: any, index: any) => {
  dataRow.value = { ...item, Index: index }
  console.log('dataRow', dataRow.value)
  refOverlayAction.value.toggle(evt)
}

const setDataRowOnState = () => {
  store.dispatch('storeRowDataTable', dataRow.value)
}

const onShowLogPassenger = () => {
  setDataRowOnState()
  isShowPassengerLog.value = true
}

const onChangeStatusRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  emit('onChangeStatusRoster')
}

const onChangeVehicleRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  emit('onChangeVehicleRoster')
}

const onDeactivateRoster = (evt: any) => {
  setDataRowOnState()
  refOverlayAction.value.toggle(evt)
  if (dataRow.value.IsActive) {
    emit('onChangeStatusActiveRoster')
  } else {
    emit('onDeactiveRoster')
  }
}

const onChangePage = (val: PageState) => {
  emit('changePage', val)
}

const timeHasBeenMissed = (end: string, time: string) => {
  // console.log('end', end)
  // console.log('time', time)
  const now = moment()
  // const endDate = moment(end.toString()).format('YYYY-MM-DD')
  const endDate = end
  const duration = moment.duration(now.diff(`${endDate} ${time}`))
  return duration.asMinutes()
}

const hideConfirmDialog = () => {
  modalConfirmation.show = false
}

const hideEditRosterDialog = () => {
  editRosterModalConfirmation.show = false
}

const showScheduleDialogAct = (data: any, rosterId: any, ppOrder: any, regNumber: any) => {
  selectedRit.value = {
    ...data,
    ppOrder,
    rosterId,
    busName: regNumber
  }
  showScheduleDialog.value = true
}

const hideScheduleDialogAct = () => {
  showScheduleDialog.value = false
  selectedRit.value = null
}

const getTimeOutEditValue = async () => {
  const response = await apiUseCase.get('settings/v1/GlobalSetting?code=BP')
  if (!response.error) {
    defaultEditTimeout.value = response.result[0].Value
    console.log('timeout', -(defaultEditTimeout.value))
  }
}

onMounted(() => {
  getTimeOutEditValue()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      expandedRows: expandedRowsList.value,
      "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((expandedRowsList).value = $event)),
      value: _unref(plottingList),
      rows: 5,
      editMode: "row",
      dataKey: "Id",
      loading: _unref(isLoading)
    }, {
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      loading: _withCtx(() => [
        _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
      ]),
      expansion: _withCtx((slotProps) => [
        _createVNode(_unref(DataTable), {
          class: _normalizeClass('roster'),
          value: slotProps.data.RosterDetails
        }, {
          empty: _withCtx(() => [
            _hoisted_26
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              header: "Urutan RIT",
              style: {"width":"120px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_27, _toDisplayString(`RIT ${data.RitOrder}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Nama RIT" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_28, _toDisplayString(data.MsRouteName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "T. Awal - T. Akhir" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_29, _toDisplayString(`${data.RitDepartureTerminal ?? '-'} - ${data.RitArrivalTerminal ?? '-'}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Jam Brngkt - Jam Dtg" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_30, _toDisplayString(`${data.RitDepartureTime ? data.RitDepartureTime.slice(0, 5) : '--:--'} - ${data.RitArrivalTime ? data.RitArrivalTime.slice(0, 5) : '--:--'}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Total Belum Check In",
              style: {"width":"150px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("p", _hoisted_32, _toDisplayString(`${data.SeatBooking - data.SeatCheckin}`), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Total Tiket Terjual",
              style: {"width":"120px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(data.SeatBooking), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Aksi" }, {
              body: _withCtx(({ data }) => [
                (slotProps.data.RosterDetails[0]?.Id === defaultGuid.value)
                  ? (_openBlock(), _createBlock(_unref(Popper), {
                      key: 0,
                      arrow: "",
                      hover: "",
                      placement: "left",
                      content: 'Rit tidak memiliki jadwal. Silahkan lengkapi jadwal terlebih dahulu.'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          class: "flex gap-2 extra-submit-button p-3",
                          outlined: true,
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _hoisted_35
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : (_openBlock(), _createBlock(_unref(Button), {
                      key: 1,
                      class: "flex gap-2 extra-submit-button p-3",
                      outlined: true,
                      onClick: ($event: any) => (showScheduleDialogAct(data, slotProps.data.Id, slotProps.data.PpOrder, slotProps.data.RegNumber))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["value"])
      ]),
      default: _withCtx(() => [
        (_unref(isRoster))
          ? (_openBlock(), _createBlock(_unref(Column), {
              key: 0,
              expander: "",
              style: {"width":"5rem"}
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(Column), {
          header: "Nopol",
          style: {"width":"150px"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("p", {
              class: _normalizeClass(!data.IsActive ? 'text-grey' : '')
            }, _toDisplayString(data.RegNumber), 3),
            (data.RosterStatusCode && data.RosterStatusName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(data.RosterStatusName), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "PP",
          style: {"width":"200px"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", {
                    class: _normalizeClass(!data.IsActive ? 'text-grey font-bold' : 'text-base font-bold'),
                    style: {"overflow-wrap":"anywhere"}
                  }, _toDisplayString(`PP ${data.PpOrder}`), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass(!data.IsActive ? 'text-grey' : '')
                  }, _toDisplayString(`(${data.DepartureTime ? data.DepartureTime.slice(0, 5) : '--:--'})`), 3)
                ]),
                (data.RosterStatusCode === 'GBG' || data.MsStatusRoster?.Code === 'GBG')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                  : (data.RosterStatusCode === 'RGL' || data.MsStatusRoster?.Code === 'RGL')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                    : (data.RosterStatusCode === 'PRW' || data.MsStatusRoster?.Code === 'PRW')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(data.RosterStatusName ?? data.MsStatusRoster?.Name), 1))
                      : _createCommentVNode("", true)
              ]),
              (_unref(isRoster))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (data.IsNonactiveRoster)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                      : _createCommentVNode("", true),
                    (data.IsVerpal)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "Driver",
          header: "Sopir",
          style: {"width":"200px"}
        }, {
          body: _withCtx(({ data, index }) => [
            (_unref(plottingSelected) === index)
              ? (_openBlock(), _createBlock(SelectAsync, {
                  key: 0,
                  endpoint: "/management/v1/User/all-user",
                  searchCustom: [['roles', '=', 'Driver'], ['activeOnly', '=', 'true']],
                  searchFields: ['name'],
                  fieldLabel: (v) => v.Fullname,
                  modelValue: rowForm.driver,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((rowForm.driver) = $event)),
                    onUpdateDriver
                  ],
                  placeholder: "Pilih Sopir",
                  classname: 'custom-select',
                  class: _normalizeClass(errorsRowForm.driver ? 'select-invalid' : '')
                }, null, 8, ["fieldLabel", "modelValue", "class"]))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(!data.IsActive ? 'text-grey' : '')
                }, _toDisplayString(data.DriverName ?? '-'), 3))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Aksi",
          bodyStyle: "text-align:center"
        }, _createSlots({ _: 2 }, [
          (_unref(isEdit))
            ? {
                name: "body",
                fn: _withCtx(({ data , index }) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(Popper), {
                      arrow: "",
                      hover: "",
                      content: data.StatusRemark ?? 'tidak ada keterangan'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["content"]),
                    (_unref(plottingSelected) === index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "cancel",
                            class: "cursor-pointer",
                            style: {"width":"37px","height":"37px"},
                            onClick: cancelEditRow
                          }),
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "save",
                            class: "cursor-pointer",
                            style: {"width":"37px","height":"37px"},
                            onClick: ($event: any) => (saveEditRow(data))
                          }, null, 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(plottingSelected) !== index && !_unref(isRoster))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "inline-flex rounded-md bg-neutral-100 gap-2 items-center px-2 py-1 cursor-pointer",
                          onClick: ($event: any) => (onEditRow(null, data))
                        }, _hoisted_21, 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (_unref(plottingSelected) !== index && _unref(isRoster) && timeHasBeenMissed(_unref(filterDate), data.DepartureTime) <= -(defaultEditTimeout.value))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "inline-flex rounded-md bg-neutral-100 gap-2 items-center px-2 py-1 cursor-pointer",
                          onClick: ($event: any) => (showDropDown($event, data, index))
                        }, _hoisted_25, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ])
              }
            : undefined
        ]), 1024)
      ]),
      _: 1
    }, 8, ["expandedRows", "value", "loading"]),
    (_unref(plottingList).length > 0)
      ? (_openBlock(), _createBlock(Paginator, {
          key: 0,
          rows: 10,
          totalRecords: _unref(totalRecords),
          onOnPage: onChangePage,
          template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        }, null, 8, ["totalRecords"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListActions, {
          editRoster: _unref(isRoster) && _unref(dataRow).IsActive ? true : false,
          viewPassengerLog: _unref(dataRow).Id,
          changeStatusRoster: false,
          changeVehicleRoster: false,
          deactiveRoster: Boolean(_unref(dataRow).DriverId),
          editRosterTitle: editRosterTitle.value,
          changeStatusRosterTitle: changeStatusRosterTitle.value,
          changeVehicleRosterTitle: changeVehicleRosterTitle.value,
          viewPassengerLogTitle: 'Log Penumpang',
          deactiveRosterTitle: _unref(dataRow).IsActive ? 'Non Aktif' : 'Aktif',
          onDeactiveRoster: _cache[2] || (_cache[2] = ($event: any) => (onDeactivateRoster($event))),
          onEditRoster: _cache[3] || (_cache[3] = ($event: any) => (onEditRow($event, _unref(dataRow)))),
          onChangeStatusRoster: _cache[4] || (_cache[4] = ($event: any) => (onChangeStatusRoster($event))),
          onChangeVehicleRoster: _cache[5] || (_cache[5] = ($event: any) => (onChangeVehicleRoster($event))),
          onViewPassengerLog: _cache[6] || (_cache[6] = ($event: any) => (onShowLogPassenger()))
        }, null, 8, ["editRoster", "viewPassengerLog", "deactiveRoster", "editRosterTitle", "changeStatusRosterTitle", "changeVehicleRosterTitle", "deactiveRosterTitle"])
      ]),
      _: 1
    }, 512),
    _createVNode(HjpAlertModal, {
      show: modalConfirmation.show,
      title: modalConfirmation.title,
      subTitle: modalConfirmation.subTitle,
      subTitleHtml: modalConfirmation.subTitleHtml,
      btnSubmitTitle: modalConfirmation.btnSubmitTitle,
      imgContent: modalConfirmation.imgContent,
      onHideDialog: hideConfirmDialog,
      onOnSubmit: hideConfirmDialog
    }, _createSlots({ _: 2 }, [
      (_unref(currentSchedules).length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSchedules), (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(data.RegNumber), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(`PP${data.PpOrder} (${data.DepartureTime})`), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]),
    _createVNode(HjpAlertModal, {
      show: editRosterModalConfirmation.show,
      title: editRosterModalConfirmation.title,
      subTitle: editRosterModalConfirmation.subTitle,
      subTitleHtml: editRosterModalConfirmation.subTitleHtml,
      btnSubmitTitle: editRosterModalConfirmation.btnSubmitTitle,
      imgContent: editRosterModalConfirmation.imgContent,
      onHideDialog: hideEditRosterDialog,
      onOnSubmit: hideEditRosterDialog
    }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]),
    _createVNode(HjpModalDefault, {
      show: isShowPassengerLog.value,
      width: '75vw',
      onHideDialog: _cache[7] || (_cache[7] = ($event: any) => (isShowPassengerLog.value = false))
    }, {
      content: _withCtx(() => [
        _createVNode(PassengerLogDialog)
      ]),
      _: 1
    }, 8, ["show"]),
    (showScheduleDialog.value)
      ? (_openBlock(), _createBlock(InfoScheduleDialog, {
          key: 1,
          show: showScheduleDialog.value,
          ritData: _unref(selectedRit),
          onHideScheduleForm: hideScheduleDialogAct
        }, null, 8, ["show", "ritData"]))
      : _createCommentVNode("", true)
  ]))
}
}

})